"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.CenteredContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  display: grid;\n  place-items: center;\n  height: 100vh;\n  width: 100vw;\n"], ["\n  background: ", ";\n  color: ", ";\n  display: grid;\n  place-items: center;\n  height: 100vh;\n  width: 100vw;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.app.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.app.color;
});
exports.CenteredContainer.displayName = 'CenteredContainer';
var Message = styled_components_1.default.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"])));
Message.displayName = 'Message';
var CenteredMessage = function (_a) {
    var message = _a.message;
    return (react_1.default.createElement(exports.CenteredContainer, null,
        react_1.default.createElement(Message, null, message)));
};
CenteredMessage.displayName = 'CenteredMessage';
exports.default = CenteredMessage;
var templateObject_1, templateObject_2;
//# sourceMappingURL=centered-message.component.js.map